import React from 'react';
import { Alert as AlertStrap } from 'reactstrap';

const Alert = ({ children, ...restProps }) => {
  //! State

  //! Function

  //! Render
  return <AlertStrap {...restProps}>{children}</AlertStrap>;
};

export default React.memo(Alert);
